const ROLES = {
  OWNER: 'owner',
  MEMBER: 'member'
}

export { ROLES }
